const initialOpenDatabase = (dbName, storeNames, dbVersion = 1) => {
  return new Promise((resolve, reject) => {
    if (typeof dbVersion !== "number" || dbVersion <= 0) {
      console.error("Invalid database version. It must be a positive integer.");
      reject(new Error("Invalid database version. It must be a positive integer."));
      return;
    }

    const request = indexedDB.open(dbName, dbVersion);
    request.onupgradeneeded = (event) => {
      const db = event.target.result;
      for (const storeName of storeNames) {
        if (!db.objectStoreNames.contains(storeName)) {
          db.createObjectStore(storeName);
        }
      }
    };

    request.onsuccess = (event) => resolve(event.target.result);
    request.onerror = (event) => reject(event.target.error);
  });
};

export default initialOpenDatabase;
